import ApplicationModel, { attr } from '../ApplicationModel';
import { type ExportPageAttributes } from './generated/ExportPageAttributes';
import { model } from '../modelBuilder';

interface ExportPage extends ExportPageAttributes {}

@model
class ExportPage extends ApplicationModel {
  // Start auto-generated
  static typename: 'ExportPage' = 'ExportPage';
  get typename(): 'ExportPage' {
    return 'ExportPage';
  }

  static inputType = 'PageAttributes!';

  static fields = {
    description: attr({ writable: true, readable: false }),
    descriptionMarkdown: attr({ writable: true, readable: false }),
    documentDate: attr({ writable: true, readable: false }),
    documentType: attr({ writable: true, readable: false }),
    editLocked: attr({ writable: true, readable: false }),
    editorVersion: attr({ writable: true, readable: false }),
    editorWidth: attr({ writable: true, readable: false }),
    emojiValue: attr({ writable: true, readable: false }),
    httpMethod: attr({ readable: true }),
    inDiscoveryParent: attr({ writable: true, readable: false }),
    location: attr({ writable: true, readable: false }),
    meetingDuration: attr({ writable: true, readable: false }),
    name: attr({ writable: true, readable: false }),
    path: attr({ readable: true }),
    position: attr({ writable: true, readable: false }),
    reviewerDocumentAccess: attr({ writable: true, readable: false }),
    showContents: attr({ writable: true, readable: false }),
    parent: attr.belongsTo({ writeShape: ['id'], readable: false }),
    project: attr.belongsTo({ writeShape: ['id'], readable: false }),
  };
  // End auto-generated
}

export default ExportPage;
